var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "#fff",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M38.94 59c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M36.44 44.06V33.94c0-.96-.4-1.34-1.42-1.34h-2.6c-1.02 0-1.42.38-1.42 1.34v10.12c0 .96.4 1.34 1.42 1.34H35c1.04 0 1.44-.38 1.44-1.34M47 44.06V33.94c0-.96-.4-1.34-1.42-1.34H43c-1.02 0-1.42.38-1.42 1.34v10.12c0 .96.4 1.34 1.42 1.34h2.58c1.02 0 1.42-.38 1.42-1.34"
  })));
};
export default SvgPending;